import { UntypedFormControl, NgModel } from '@angular/forms';
import { format } from 'date-fns';

export const getErrorMessage = (formControl: UntypedFormControl | NgModel) => {
  if (formControl.hasError('required')) {
    return 'This field is required';
  }
  if (formControl.hasError('futureDate')) {
    return 'Date cannot be in the future';
  }
  if (formControl.hasError('pattern')) {
    // TODO: Will need to do a check on the pattern
    return 'Invalid pattern.';
  }
  if (formControl.hasError('matDatepickerMin')) {
    const error = formControl.getError('matDatepickerMin');
    return `Date cannot be before ${format(error.min, 'MMMM d, y')}`;
  }
  if (formControl.hasError('matDatepickerParse')) {
    return `Invalid date format please use MM/DD/YYYY`;
  }
  if (formControl.hasError('minlength')) {
    const error = formControl.getError('minlength');
    return `Must be at least ${error.requiredLength} characters`;
  }
  if (formControl.hasError('mustMatch')) {
    const error = formControl.getError('mustMatch');
    return `Passwords must match`;
  }
  if (formControl.hasError('max')) {
    const error = formControl.getError('max');
    return `Number must be below ${error.max}`;
  }
  if (formControl.hasError('emailOrEmpty')) {
    // const error = formControl.getError('emailOrEmpty');
    return `Invalid email address`;
  }
  if (formControl.hasError('email')) {
    // const error = formControl.getError('email');
    return `Invalid email address`;
  }
  if (formControl.hasError('digitsOnly')) {
    //  const error = formControl.getError('digitsOnly');
    return `Input can only contain numbers [0-9]`;
  }
  if (formControl.hasError('min')) {
    const error = formControl.getError('min');
    return `Number must be above ${error.min}`;
  }
  if (formControl.hasError('phone')) {
    return `Phone number invalid`;
  }

  if (formControl.hasError('other')) {
    const error = formControl.getError('other');
    return error;
  }

  if (formControl.hasError('asciiValidator')) {
    const error = formControl.getError('asciiValidator');
    return error.value;
  }

  if (formControl.errors) {
    console.warn('No error message defined', formControl.errors);
    return 'Input is invalid';
  }
};
